import PropTypes from 'prop-types';
import clsx from 'clsx';
import { isEmpty } from '@/helpers/is';
import classes from './extra.module.css';

const Extra = (props) => {
  const {
    children,
    size = 'md',
  } = props;

  const extraClasses = clsx(classes.extra, size !== 'md' && classes[size]);

  if (isEmpty(children)) {
    return null;
  }

  return (
    <div className={extraClasses}>{children}</div>
  );
};

Extra.propTypes = {
  children: PropTypes.any,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
};

export default Extra;
